import React from 'react';

import Immutable from 'seamless-immutable';

import { BrokenImageOutlined } from '@material-ui/icons';

import { object } from 'prop-types';
import { generate } from 'shortid';
import { withTheme } from 'styled-components';

import { formatMoney, createProductLink } from '../../../../../../../libs';
import { useWindowSize } from '../../../../../../../libs/useWindowSize';
import LodingCircle from '../../../../../../LoadingCircle';
import NoPrice from '../../../../../../NoPrice';

import {
  CardStyled,
  CardMediaStyled,
  ProductName,
  CardActionAreaStyled,
  ProductInfo,
  CardLink,
  ProducInfoContainer,
  ProductTags,
  Tag,
  ProductId,
  ProductDiscount,
} from './styles';

function compareByLength(a, b) {
  if (a.descricao.length > b.descricao.length) {
    return 1;
  }

  if (a.descricao.length < b.descricao.length) {
    return -1;
  }

  return 0;
}
function HeaderProductCard({ product, theme }) {
  const [width] = useWindowSize();

  return (
    <CardStyled>
      <CardLink
        href={createProductLink(product.name, product.id)}
        title={product.name}
        alt={product.name}
        aria-label={product.name}
        target="_self"
        rel="noopener"
      >
        <CardActionAreaStyled>
          {product.getIn(['salesPrice', 'discount']) && (
            <ProductDiscount>{`-${Math.trunc(product.getIn(['salesPrice', 'discount', 'rate']))}%`}</ProductDiscount>
          )}
          <CardMediaStyled image={product.image || ''} src={product.image || ''}>
            {!product.image && product.loaded && <BrokenImageOutlined />}
            <LodingCircle isLoading={!product.loaded} />
          </CardMediaStyled>
          {width > 768 && <ProductId>{product.id}</ProductId>}
          <ProductName>{product.name}</ProductName>
          {width > 768 && (
            <ProductTags container wrap="wrap">
              {product.getIn(['tags']) &&
                product
                  .getIn(['tags'])
                  .asMutable()
                  .sort(compareByLength)
                  .map((tag) => (
                    <Tag key={`tag-${generate()}`} color={tag.color} title={tag.title} background={tag.background}>
                      {tag.descricao}
                    </Tag>
                  ))}
            </ProductTags>
          )}
          {!product.getIn(['showPrice']) && <NoPrice />}
          {product.getIn(['showPrice']) && (
            <ProducInfoContainer container direction="column">
              <ProductInfo color="#555555" linethroung="true">
                {product.getIn(['listPrice', 'value']) > product.getIn(['salesPrice', 'value'])
                  ? formatMoney(product.getIn(['listPrice', 'value']))
                  : ''}
              </ProductInfo>
              <ProductInfo color={theme.colors.secondary} bold="true">
                {product.getIn(['salesPrice', 'value']) ? formatMoney(product.getIn(['salesPrice', 'value'])) : ''}
              </ProductInfo>
            </ProducInfoContainer>
          )}
        </CardActionAreaStyled>
      </CardLink>
    </CardStyled>
  );
}

HeaderProductCard.propTypes = {
  product: object,
  theme: object,
};

HeaderProductCard.defaultProps = {
  product: Immutable({}),
};

export default withTheme(HeaderProductCard);
